var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { ListService, Pager } from './list.service';
var ListCountComponent = /** @class */ (function (_super) {
    __extends(ListCountComponent, _super);
    function ListCountComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.pager = new Pager();
        return _this;
    }
    ListCountComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    ListCountComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    ListCountComponent.prototype.onSubscribe = function (data) {
        this.pager = new Pager();
        if (typeof data !== 'undefined') {
            this.pager.count = data.totalRowCount;
        }
    };
    ListCountComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    ListCountComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'listcount',
                    template: "<p id=\"{{ componentName }}\">\n  <span class=\"sectionHeading sectionHeading-gray\">{{ (msg | async)['ListComponent.label.result1'] }}{{ pager.count }}{{ (msg | async)['ListComponent.label.result2'] }}</span><span\n    class=\"-note -ml-05 -autoBreak\">/ {{ (msg | async)['ListComponent.label.total1'] }}{{ (msg | async)['ListComponent.label.total2'] }}</span>\n</p>\n"
                }] }
    ];
    /** @nocollapse */
    ListCountComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ListService }
    ]; };
    return ListCountComponent;
}(ContentBaseComponent));
export { ListCountComponent };
//# sourceMappingURL=count.component.js.map